import { classNames } from "@greeter/util";
import { HTMLMotionProps, motion } from "motion/react";

import css from "./Card.module.scss";

type CardVariant =
  | "regular"
  | "green"
  | "moody-green"
  | "bright-green"
  | "bright-green-hollow"
  | "yellow"
  | "dark"
  | "dark-blue";
type CardAct = "button" | "card";

export type CardProps = HTMLMotionProps<"div"> & {
  variant?: CardVariant;
  borderless?: boolean;
  act?: CardAct;
  disabled?: boolean;
  onDisabledClick?: HTMLMotionProps<"div">["onClick"];
};

export function Card({
  className,
  variant,
  act,
  disabled,
  borderless,
  onClick,
  onDisabledClick,
  ...props
}: CardProps) {
  return (
    <motion.div
      {...classNames(
        className,
        css.Card,
        variant === "green" && css.Green,
        variant === "moody-green" && css.MoodyGreen,
        variant === "bright-green" && css.BrightGreen,
        variant === "bright-green-hollow" && css.BrightGreenHollow,
        variant === "yellow" && css.Yellow,
        variant === "dark" && css.Dark,
        variant === "dark-blue" && css.DarkBlue,
        borderless && css.Borderless,
        act === "button" && css.AsButton,
        disabled && css.Disabled
      )}
      onClick={(ev) => {
        if (disabled) {
          onDisabledClick?.(ev);
          return;
        }
        onClick?.(ev);
      }}
      {...props}
    />
  );
}

export type CardContentProps = HTMLMotionProps<"div"> & {
  padding?: "sm";
  preset?: "flex-aligned-center";
};
Card.Content = function CardContent({
  className,
  padding,
  preset,
  ...props
}: CardContentProps) {
  return (
    <motion.div
      {...classNames(
        className,
        css.Content,
        padding === "sm" && css.sm,
        preset === "flex-aligned-center" && css.FlexAlignedCenter
      )}
      {...props}
    />
  );
};
